/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

const is = require("is_js");

const SERVICE_NAME = "CommitteeDiscountListService";
const log: any = LoggerModule.getInstance();

export class CommitteeDiscountListService {
  private static instance: CommitteeDiscountListService;
  private criteria: any;

  private constructor(props: any = {}) { }
  public static getInstance(props: any = {}): CommitteeDiscountListService {
    if (!CommitteeDiscountListService.instance) {
      CommitteeDiscountListService.instance = new CommitteeDiscountListService(
        props
      );
    }
    return CommitteeDiscountListService.instance;
  }
  private setCriteria(data: any) {
    this.criteria = data;
  }

  public resetCriteria() {
    this.criteria = null;
  }
  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }


  public async getCommDisList(args?: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();
    if (args) {
      this.setCriteria(args);
    }
    compProps = await agent.getCommDisList(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }
    console.log(content);
    return content;
  }


}
